import { store } from '../store';
import {
    RESET_QUESTIONNAIRE,
    INITIATE_QUESTIONNAIRE,
    INITIATE_QUESTIONNAIRE_SUCCESS,
    INITIATE_QUESTIONNAIRE_FAILURE,
    SEND_QUESTION,
    SEND_QUESTION_SUCCESS,
    SEND_QUESTION_FAILURE,
    REMOVE_LAST_QUESTION,
    REMOVE_LAST_QUESTION_SUCCESS,
    UPDATE_CURRENT_QUESTIONNAIRE,
    UPDATE_CURRENT_QUESTIONNAIRE_SUCCESS,
} from '../../constants';
import {
    client as graphQlClient,
    START_QUESTIONNAIRE,
    SEND_QUESTION_ANSWER,
} from '../../graphql';

export const resetQuestionnaire = () => ({
    type: RESET_QUESTIONNAIRE,
    error: null,
    isLoading: false,
});

export const initiateQuestionnaireSuccess = (payload) => ({
    type: INITIATE_QUESTIONNAIRE_SUCCESS,
    payload,
    error: null,
    isLoading: false,
});

export const initiateQuestionnaireFailure = (error) => ({
    type: INITIATE_QUESTIONNAIRE_FAILURE,
    error,
    isLoading: false,
});

export const sendQuestionSuccess = (payload) => ({
    type: SEND_QUESTION_SUCCESS,
    payload,
    error: null,
    isLoading: false,
});

export const sendQuestionFailure = (error) => ({
    type: SEND_QUESTION_FAILURE,
    error,
    isLoading: false,
});

export const removeLastQuestionSuccess = (questionnaireState) => ({
    type: REMOVE_LAST_QUESTION_SUCCESS,
    questionnaireState,
    error: null,
    isLoading: false,
});

export const updateCurrentQuestionnaireSuccess = (questionState) => ({
    type: UPDATE_CURRENT_QUESTIONNAIRE_SUCCESS,
    questionState,
    error: null,
    isLoading: false,
});

export const initiateQuestionnaire =
    (productID) => async (dispatch) => {
        try {
            dispatch({
                type: INITIATE_QUESTIONNAIRE,
                isLoading: true,
            });

            await graphQlClient
                .mutate({
                    mutation: START_QUESTIONNAIRE,
                    variables: { productID },
                    fetchPolicy: 'no-cache',
                })
                .then((data) => {
                    const {
                        data: {
                            startOver: {
                                sessionId,
                                nextQuestionnaire,
                            },
                        },
                    } = data;

                    const questionnaire = {
                        sessionID: sessionId,
                        questionnaire: nextQuestionnaire[0],
                    };

                    dispatch(
                        initiateQuestionnaireSuccess(questionnaire),
                    );
                });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.log(err);
            dispatch(initiateQuestionnaireFailure(err));
        }
    };

export const sendQuestion = (payload) => async (dispatch) => {
    try {
        dispatch({ type: SEND_QUESTION, isLoading: true });
        const {
            productID,
            sessionID,
            customerID,
            questionID,
            answerInfo,
        } = payload;

        const answerID = answerInfo[questionID];

        await graphQlClient
            .mutate({
                mutation: SEND_QUESTION_ANSWER,
                variables: {
                    productID,
                    sessionID,
                    customerID,
                    questionID,
                    answerID,
                },
                fetchPolicy: 'no-cache',
            })
            .then((data) => {
                const {
                    data: {
                        pullQuestionnaire: {
                            sessionId,
                            nextQuestionnaire,
                        },
                    },
                } = data;

                const {
                    questionnaireReducer: {
                        questionnaire: { metaData, answers },
                    },
                } = store.getState();
                const questionnaire = {
                    sessionID: sessionId,
                    questionnaire:
                        nextQuestionnaire && nextQuestionnaire[0]
                            ? nextQuestionnaire[0]
                            : nextQuestionnaire,
                    questionState: {
                        id: questionID,
                        currentAnswer: answerID,
                        answers,
                        metaData,
                    },
                };
                dispatch(sendQuestionSuccess(questionnaire));
            });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
        dispatch(sendQuestionFailure(err));
    }
};

export const removeLastQuestion = () => (dispatch) => {
    dispatch({ type: REMOVE_LAST_QUESTION });
    const {
        questionnaireReducer: { questionnaireState },
    } = store.getState();
    const questionnaire = questionnaireState.slice(0, -1);
    dispatch(removeLastQuestionSuccess(questionnaire));
};

export const updateCurrentQuestionnaire = () => (dispatch) => {
    dispatch({ type: UPDATE_CURRENT_QUESTIONNAIRE });
    const {
        questionnaireReducer: { questionnaireState },
    } = store.getState();
    dispatch(
        updateCurrentQuestionnaireSuccess(
            questionnaireState[questionnaireState.length - 1],
        ),
    );
};
